import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_RATING, RATINGS_OPTIONS } from 'client/data/models/consumer-reviews';
import { StyledSelect } from 'client/site-modules/shared/components/styled-select/styled-select';

export function RatingSelect({ rating, setStarRating }) {
  return (
    <Fragment>
      <label id="select-rating-label" htmlFor="select-rating" className="heading-5">
        Filter by:
      </label>
      <StyledSelect
        value={rating.toString()}
        options={RATINGS_OPTIONS}
        onChange={setStarRating}
        name="select-rating"
        isFirstOptionDisabled={false}
        defaultValue={DEFAULT_RATING}
        valueKey="value"
        labelKey="label"
        className="heading-5-inline ps-0_5 rounded"
        aria-labelledby="select-rating-label"
      />
    </Fragment>
  );
}

RatingSelect.propTypes = {
  setStarRating: PropTypes.func.isRequired,
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
